import {useEffect} from "react";
import {useStore} from "./useStore";
import {useLocation} from "react-router-dom/cjs/react-router-dom";
import config from "../_core/config";

export const useGoogleAnalytics = () => {
    const location = useLocation();
    const stores = useStore();
    useEffect(() => {
        if (typeof window !== "undefined" && window.gtag && location) {
            const getUserInfo = () => {
                if (typeof window !== "undefined" && stores?.meStore) {
                    const userInfo = {
                        username: stores?.meStore?.username || "anonymous",
                        role: stores?.meStore?.role || "unknown",
                        userId: stores?.meStore?.userId || "unknown"
                    };

                    if (
                        stores?.meStore?.role === "cUser" &&
                        stores?.meStore?.selectedSubCompanyId
                    ) {
                        userInfo.selectedSubCompanyId = stores?.meStore?.selectedSubCompanyId;
                    }

                    return userInfo;
                }
                return {
                    username: "anonymous",
                    role: "unknown",
                    userId: "unknown"
                };
            };

            const userInfo = getUserInfo();

            // Sadece cUser rolüne sahip kullanıcılar için Google Analytics'i aktif et
            if (userInfo.role === "cUser") {
                // Google Analytics'i aktifleştir
                const eventData = {
                    page_path: location.pathname + location.search,
                    page_title: document.title,
                    custom_parameter_username: userInfo.username,
                    custom_parameter_role: userInfo.role,
                    custom_parameter_user_id: userInfo.userId
                };

                if (userInfo.selectedSubCompanyId) {
                    eventData.custom_parameter_subcompany_id = userInfo.selectedSubCompanyId;
                }
                window.gtag("config", config.tagId, eventData);
            } else {
                // cUser olmayan kullanıcılar için Google Analytics'i devre dışı bırak
                if (window.gtag) {
                    window.gtag("config", config.tagId, {
                        send_page_view: false,
                        anonymize_ip: true,
                        custom_parameter_role: userInfo.role
                    });
                }
            }
        }
    }, [location, stores]);
};
